export default __webpack_public_path__ + "static/media/codex_reboot_button.fd27df42.jpg";